var map = {
	"./agent/agent.module.ngfactory": [
		"./src/app/agent/agent.module.ngfactory.js",
		"agent-agent-module-ngfactory"
	],
	"./blog/blog.module.ngfactory": [
		"./src/app/blog/blog.module.ngfactory.js",
		"blog-blog-module-ngfactory"
	],
	"./profile/profile.module.ngfactory": [
		"./src/app/profile/profile.module.ngfactory.js",
		"profile-profile-module-ngfactory"
	],
	"./project/project.module.ngfactory": [
		"./src/app/project/project.module.ngfactory.js",
		"project-project-module-ngfactory"
	],
	"./vastu-services/vastu-services.module.ngfactory": [
		"./src/app/vastu-services/vastu-services.module.ngfactory.js",
		"vastu-services-vastu-services-module-ngfactory"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;